/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common';
import '../../common/time';

const $root =
  $protobuf.roots['default'] ||
  ($protobuf.roots['default'] = new $protobuf.Root());

const jsonData = {
  squareup: {
    nested: {
      rewards: {
        nested: {
          rewardCode: {
            nested: {
              RewardCode: {
                fields: {
                  id: {
                    type: 'int64',
                    id: 1,
                    rule: 'optional',
                  },
                  type: {
                    type: '.squareup.rewards.rewardCode.RewardCode.Type',
                    id: 2,
                    rule: 'optional',
                  },
                  reward: {
                    type: '.squareup.rewards.Reward',
                    id: 5,
                    rule: 'optional',
                  },
                  token: {
                    type: 'string',
                    id: 6,
                    rule: 'optional',
                  },
                  uses: {
                    type: 'int32',
                    id: 7,
                    rule: 'optional',
                  },
                  maxUses: {
                    type: 'int32',
                    id: 8,
                    rule: 'optional',
                  },
                  expiresAt: {
                    type: '.squareup.common.time.DateTime',
                    id: 9,
                    rule: 'optional',
                  },
                  campaign: {
                    type: '.squareup.rewards.Campaign',
                    id: 10,
                    rule: 'optional',
                  },
                  rewardCodeBranding: {
                    type: '.squareup.rewards.rewardCode.RewardCodeBranding',
                    id: 11,
                    rule: 'optional',
                  },
                  rewardCodeSender: {
                    type: '.squareup.rewards.rewardCode.RewardCodeSender',
                    id: 12,
                    rule: 'optional',
                  },
                  countryCode: {
                    type: 'string',
                    id: 13,
                    rule: 'optional',
                  },
                  rewardProgram: {
                    type: 'string',
                    id: 14,
                    rule: 'optional',
                  },
                  referralUrl: {
                    type: 'string',
                    id: 15,
                    rule: 'optional',
                  },
                  rewardDetails: {
                    type: '.squareup.rewards.rewardCode.RewardDetail',
                    id: 16,
                    rule: 'repeated',
                  },
                  wasCreatedWithMultiRewardTool: {
                    type: 'bool',
                    id: 17,
                    rule: 'optional',
                  },
                  isSquareOneIncompatible: {
                    type: 'bool',
                    id: 18,
                    rule: 'optional',
                  },
                  senderUnitToken: {
                    type: 'string',
                    id: 3,
                  },
                  senderMerchantToken: {
                    type: 'string',
                    id: 4,
                  },
                },
                nested: {
                  Type: {
                    values: {
                      SQUARE: 1,
                      MERCHANT: 2,
                      PARTNER: 3,
                      RECEIPT: 4,
                      REAL_MONEY: 5,
                      QR_CODE: 6,
                      SQUARE_BUYER_PERSON: 7,
                    },
                  },
                  sender_token: {
                    oneof: ['senderUnitToken', 'senderMerchantToken'],
                  },
                },
              },
              RewardCodeUse: {
                fields: {
                  id: {
                    type: 'int64',
                    id: 1,
                    rule: 'optional',
                  },
                  rewardCode: {
                    type: '.squareup.rewards.rewardCode.RewardCode',
                    id: 4,
                    rule: 'optional',
                  },
                  activated: {
                    type: 'bool',
                    id: 5,
                    rule: 'optional',
                  },
                  active: {
                    type: 'bool',
                    id: 6,
                    rule: 'optional',
                  },
                  receiverUnitToken: {
                    type: 'string',
                    id: 2,
                  },
                  receiverMerchantToken: {
                    type: 'string',
                    id: 3,
                  },
                },
                nested: {
                  receiver_token: {
                    oneof: ['receiverUnitToken', 'receiverMerchantToken'],
                  },
                },
              },
              RewardCodeBranding: {
                fields: {
                  headline: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  copy: {
                    type: 'string',
                    id: 2,
                    rule: 'repeated',
                  },
                  finePrint: {
                    type: 'string',
                    id: 3,
                    rule: 'repeated',
                  },
                  imageUrl: {
                    type: 'string',
                    id: 4,
                    rule: 'optional',
                  },
                  partner: {
                    type: 'string',
                    id: 5,
                    rule: 'optional',
                  },
                  countryCode: {
                    type: 'string',
                    id: 6,
                    rule: 'optional',
                  },
                  mobileCopy: {
                    type: 'string',
                    id: 7,
                    rule: 'optional',
                  },
                  mobileHeadline: {
                    type: 'string',
                    id: 8,
                    rule: 'optional',
                  },
                  mobileEmailBody: {
                    type: 'string',
                    id: 9,
                    rule: 'optional',
                  },
                  fullUrl: {
                    type: 'string',
                    id: 10,
                    rule: 'optional',
                  },
                  mobileUrl: {
                    type: 'string',
                    id: 11,
                    rule: 'optional',
                  },
                  hidePartnerName: {
                    type: 'bool',
                    id: 12,
                    rule: 'optional',
                  },
                  customFooter: {
                    type: 'string',
                    id: 13,
                    rule: 'optional',
                  },
                  hideSquareLogo: {
                    type: 'bool',
                    id: 14,
                    rule: 'optional',
                  },
                },
              },
              RewardCodeSender: {
                fields: {
                  senderType: {
                    type: '.squareup.rewards.rewardCode.RewardCodeSender.SenderType',
                    id: 3,
                    rule: 'optional',
                  },
                  createdAt: {
                    type: '.squareup.common.time.DateTime',
                    id: 4,
                    rule: 'optional',
                  },
                  updatedAt: {
                    type: '.squareup.common.time.DateTime',
                    id: 5,
                    rule: 'optional',
                  },
                  unitToken: {
                    type: 'string',
                    id: 1,
                  },
                  merchantToken: {
                    type: 'string',
                    id: 2,
                  },
                },
                nested: {
                  SenderType: {
                    values: {
                      SQUARE: 1,
                      MERCHANT: 2,
                      PARTNER: 3,
                      RECEIPT: 4,
                    },
                  },
                  sender_token: {
                    oneof: ['unitToken', 'merchantToken'],
                  },
                },
              },
              RewardDetail: {
                fields: {
                  rewardHeading: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  rewardContents: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

// Do not initialize these protos if they have already been defined
if (
  !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested
    ?.RewardCode &&
  !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested
    ?.RewardCode?.nested?.Type &&
  !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested
    ?.RewardCodeUse &&
  !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested
    ?.RewardCodeBranding &&
  !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested
    ?.RewardCodeSender &&
  !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested
    ?.RewardCodeSender?.nested?.SenderType &&
  !$root.nested?.squareup?.nested?.rewards?.nested?.rewardCode?.nested
    ?.RewardDetail
) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RewardCode @ squareup/rewards/rewardCode/model.proto at 9:1
 */
export const RewardCode = $root.lookupType(
  'squareup.rewards.rewardCode.RewardCode'
);
fixType(RewardCode);
Builder.createAndAttachToType(RewardCode);
/**
 * SOURCE Type @ squareup/rewards/rewardCode/model.proto at 10:3
 */
RewardCode.Type = $root.lookupEnum(
  'squareup.rewards.rewardCode.RewardCode.Type'
).values;
/**
 * SOURCE RewardCodeUse @ squareup/rewards/rewardCode/model.proto at 50:1
 */
export const RewardCodeUse = $root.lookupType(
  'squareup.rewards.rewardCode.RewardCodeUse'
);
fixType(RewardCodeUse);
Builder.createAndAttachToType(RewardCodeUse);
/**
 * SOURCE RewardCodeBranding @ squareup/rewards/rewardCode/model.proto at 67:1
 */
export const RewardCodeBranding = $root.lookupType(
  'squareup.rewards.rewardCode.RewardCodeBranding'
);
fixType(RewardCodeBranding);
Builder.createAndAttachToType(RewardCodeBranding);
/**
 * SOURCE RewardCodeSender @ squareup/rewards/rewardCode/model.proto at 88:1
 */
export const RewardCodeSender = $root.lookupType(
  'squareup.rewards.rewardCode.RewardCodeSender'
);
fixType(RewardCodeSender);
Builder.createAndAttachToType(RewardCodeSender);
/**
 * SOURCE SenderType @ squareup/rewards/rewardCode/model.proto at 91:3
 */
RewardCodeSender.SenderType = $root.lookupEnum(
  'squareup.rewards.rewardCode.RewardCodeSender.SenderType'
).values;
/**
 * SOURCE RewardDetail @ squareup/rewards/rewardCode/model.proto at 108:1
 */
export const RewardDetail = $root.lookupType(
  'squareup.rewards.rewardCode.RewardDetail'
);
fixType(RewardDetail);
Builder.createAndAttachToType(RewardDetail);
